import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Divider, Tooltip, Button, Image, Input, Select, Spin, Skeleton } from 'antd';
import constants from '../../../constants/constants';
import { getColorClass } from '../../../functions/functions';
import { PlayCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { fetchApi } from '../../../services/api';
import SearchResultInfo from '../Common/SearchResultInfo';
const { Meta } = Card;
const { Search } = Input;
const VideoResources = () => {
  const navigate = useNavigate();
  const [videoList, setVideoList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filterVideoList, setFilterVideoList] = useState([]);
  const [totalVideos, setTotalVideos] = useState(0);
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [chapterId, setChapterId] = useState(sessionStorage.getItem("chapterId") ? sessionStorage.getItem("chapterId") : location?.state?.chapter_id ? location?.state?.chapter_id : "all" );
  const [chapterListing, setChapterListing] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    getChapterListing();
    getVideoList();
  }, [chapterId]);

  useEffect(() => {
    return () => {
      // Remove the session here
      sessionStorage.removeItem('chapterId');
    };
  }, []);

  const getVideoList = () => {
    setLoader(true);
    let payload ={}
    if (chapterId !== "all") {
			payload.chapter_id = chapterId;
		} 
    fetchApi(`/video-list`, 'post',payload).then((res) => {
			if (res?.code === 200) {
        setLoader(false);
				setVideoList(res?.data);
        setFilterVideoList(res?.data);
			}else{
        setLoader(false);
        setVideoList([]);
        setFilterVideoList([]);
      }
		})
  };

  const renderVideo = (id, title, filename) => {
    const nameWithoutExtension = filename?.substring(0, filename?.lastIndexOf("."));
    const state = {
      videoId: id,
      videoName: title,
      filename: nameWithoutExtension 
    };
    navigate('/video', { state });
  };

  const filterDataByVideoCaption = (searchTerm) => {
		const filteredAndMappedData = filterVideoList.map((categoryVideos) => {
			const filteredItems = categoryVideos.videoList.filter((item) =>  item?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()));
			const mappedItems = filteredItems.map((item) => ({
				...item,
			}));
			// Return the group with filtered and mapped items
			return {
				...categoryVideos,
				videoList: mappedItems,
			};
		}).filter((group) => group.videoList.length > 0);
    const totalVideos = filteredAndMappedData?.reduce((acc, item) => acc + item.videoList.length, 0);
    setFilterSearchValue(searchTerm);
    setTotalVideos(totalVideos);
		setVideoList(filteredAndMappedData);
	};

  const onChangeSearch =(e)=>{
		setSearchValue(e.target.value);
	};

  const getChapterListing = () => {
    fetchApi(`/chapter-videos`, 'get').then((res) => {
      if (res?.code === 200) {
        let chapters = res?.data
        // adding all chapter obj
        let newObj = {
          chapter: "All Chapters",
          chapter_id: "all"
        }
        chapters.unshift(newObj);
        setChapterListing(chapters);
      } else {
        setChapterListing([]);
      }
    })
  };
  const onChangeChapters = (value) => {
		setSearchValue("");
		setFilterSearchValue("");
		setVideoList([]);
		setChapterId(value);
		sessionStorage.setItem("chapterId", value);
	};

  return (
    <div>
      <div className='container mx-auto'>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          {/* Title */}
          <div className="text-2xl underline underline-offset-4 font-extrabold uppercase"
            style={{ color: getColorClass("1", "colorcode") }}>
            {constants.Videos}
          </div>
          {/* Right Section: Search + Button */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto">
            <Select onChange={onChangeChapters} className='!w-80 lg:!w-[450px]' value={chapterId}>
              {chapterListing.length > 0 ? chapterListing?.map((listChapter) => (
                <Option key={listChapter.chapter_id} value={listChapter.chapter_id}>
                  {listChapter.chapter}
                </Option>
              )) : null}
            </Select>
            <Search
              className="w-full sm:w-60"
              allowClear
              placeholder="Search"
              value={searchValue}
              onSearch={(e) => filterDataByVideoCaption(e)}
              onChange={onChangeSearch}
              enterButton={
                <Button
                  type="primary"
                  style={{
                    backgroundColor: searchValue ? 'rgb(29 78 216 / var(--tw-bg-opacity))' : '#d9d9d9',
                    borderColor: searchValue ? 'rgb(29 78 216 / var(--tw-bg-opacity))' : '#d9d9d9',
                    color: searchValue ? '#fff' : 'rgba(0, 0, 0, 0.45)',
                  }}
                  icon={<SearchOutlined />}
                  disabled={ !searchValue }
                ></Button>
              }
            />
          </div>
        </div>
        <SearchResultInfo totalResults={totalVideos} searchValue={filterSearchValue} />
        <Divider className='my-2' />
        <Spin spinning={loader} size="large" className='z-30'>
        {
          loader ? (
            <>
              <Skeleton.Input active size="large" />
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 mt-3'>
                {[...Array(5)].map((_, i) => (
                  <Skeleton.Image key={i} active size="large" className='!w-full !h-64' />
                ))}
              </div>
            </>
          ) :
          !loader && videoList.length === 0 ? (
            <div className='text-black font-semibold text-center text-2xl'>No Videos to display</div>
          ) :
          videoList.length > 0 && 
            videoList.map((val, index) => (
              val?.videoList?.length > 0 && (
                <div className='' key={index}>
                  <div style={{ backgroundColor: getColorClass("1", "colorcode") }} className='flex justify-between items-center mt-3 py-2.5 px-5'>
                    <div className='text-white font-extrabold text-xl'>{val.name}</div>
                  </div>
                  <Card style={{ borderColor: getColorClass("1", "colorcode") }} className='rounded-none border'>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3'>
                      {
                        val.videoList.map((videoDetails, idx) => (
                          <div
                            key={idx}
                            className="border-black border rounded-none cursor-pointer"
                            onClick={() => renderVideo(videoDetails?.resource_file_id, videoDetails?.title, videoDetails?.resource_name)}
                          >
                            <div className="relative group flex items-center justify-center custom-video-card">
                              <Image
                                className="cursor-pointer object-cover !w-full"
                                preview={false}
                                src={videoDetails?.image}
                                alt={videoDetails?.title}
                              />
                              {/* Duration Tag */}
                              <div className="absolute bottom-2.5 right-1 bg-black bg-opacity-70 text-white text-sm font-semibold px-1.5 py-0.5 rounded">
                                {videoDetails?.duration}
                              </div>
                              {/* Hover Overlay with Play Icon */}
                              <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                                <PlayCircleOutlined className="text-white text-4xl" />
                              </div>
                            </div>
                            {/* Caption with Tooltip */}
                            <Tooltip title={videoDetails?.title}>
                              <div className="bg-gray-300 p-1 font-bold whitespace-nowrap overflow-hidden text-ellipsis w-full">
                                {videoDetails?.title}
                              </div>
                            </Tooltip>
                          </div>
                        ))
                      }
                    </div>
                  </Card>
                </div>
              )
            ))
        }
        </Spin>
      </div>
    </div>
  )
}

export default VideoResources;